module.exports = __webpack_public_path__ + "static/media/file-check-alt.3062c8cb.svg";